import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RouteKeys} from '../../constants';
import {ValidationService, StringService} from '../../services';
import {InputText, ScreenNotificationDefault, Footer} from '../../components';
import validation from './validation';
import validationWithoutConfirmEmail from './validationWithoutConfirmEmail';
import {
  redirectToEndDataRegistration,
  redirectToDataRegistration,
} from '../../ducks/Navigate';
import {
  dadosPessoaisPreAdicionar,
  updateDadosPessoais,
} from '../../ducks/Customer';

import './styles.scss';
class DataContact extends Component {
  state = {emailChanged: false};

  formIsValid = () =>
    ValidationService.validate(
      this.props.dadosPessoais,
      this.checkVia('EMAIL') || this.checkVia('MGM')
        ? validationWithoutConfirmEmail
        : validation,
    );

  handleSubmit = async (event) => {
    event.preventDefault();

    if (!this.formIsValid()) return;
    let celularOriginalConvite = this.props.celularOriginalConvite;

    let chave = this.props.chave;
    let via = this.props.via;
    let realizouPreAvaliacao = this.props.realizouPreAvaliacao;
    let autorizacoes = this.props.autorizacoes;

    this.props.dadosPessoaisPreAdicionar({
      chave,
      ...this.props.dadosPessoais,
      celularOriginalConvite,
      via,
      realizouPreAvaliacao,
      autorizacoes,
    });
  };

  componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.DataContact.title);
    this.setState({emailOriginal: this.props.dadosPessoais.email});
  }

  handleChange = (prop, value) => {
    this.props.updateDadosPessoais({prop, value});
  };

  checkVia = (parameter) => {
    return this.props.via === parameter;
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Contato</p>}
        contentCustom={
          <form className="form" id="frm" onSubmit={this.handleSubmit}>
            <InputText
              id="email"
              name="email"
              type="email"
              value={this.props.dadosPessoais.email}
              onPaste={(ev) => ev.preventDefault()}
              onChange={(ev) => this.handleChange('email', ev.target.value)}
              placeholder="E-mail"
              disabled={this.checkVia('EMAIL')}
            />

            {!this.checkVia('EMAIL') && (
              <InputText
                id="confirmacaoEmail"
                name="confirmacaoEmail"
                type="email"
                value={this.props.dadosPessoais.confirmacaoEmail}
                onPaste={(ev) => ev.preventDefault()}
                autoComplete="off"
                onChange={(ev) =>
                  this.handleChange('confirmacaoEmail', ev.target.value)
                }
                placeholder="Confirme o e-mail"
              />
            )}

            <InputText
              id="celular"
              type="tel"
              name="celular"
              value={this.props.dadosPessoais.celular}
              onChange={(ev) => this.handleChange('celular', ev.target.value)}
              placeholder="DDD + Número do Celular"
              mask="(99) 99999-9999"
              disabled={this.checkVia('SMS') || this.checkVia('MGM')}
            />

            <InputText
              id="telephone"
              type="tel"
              name="telephone"
              value={this.props.dadosPessoais.telefoneResidencial}
              onChange={(ev) =>
                this.handleChange('telefoneResidencial', ev.target.value)
              }
              placeholder="DDD + Telefone Fixo (Opcional)"
              mask="(99) 9999-9999"
            />
          </form>
        }
        contentButtons={
          <div className="div-data-contact">
            <Footer
              nextForm="frm"
              backHandle={this.props.redirectToDataRegistration}
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer}) => {
  console.log(`Costumer -> ${JSON.stringify(customer)}`);
  const {
    chave,
    naturalidade,
    dadosPessoais,
    via,
    celularOriginalConvite,
    situacao,
    realizouPreAvaliacao,
    autorizacoes,
  } = customer;
  return {
    chave,
    naturalidade,
    dadosPessoais,
    via,
    celularOriginalConvite,
    situacao,
    realizouPreAvaliacao,
    autorizacoes,
  };
};

export default connect(mapStateToProps, {
  redirectToEndDataRegistration,
  updateDadosPessoais,
  redirectToDataRegistration,
  dadosPessoaisPreAdicionar,
})(DataContact);
